/* FERRY AUTO-GENERATED: DO NOT EDIT THIS FILE */ /* eslint-disable */ // @ts-nocheck
import { ferryFetch } from "@ecom-alliance/libs";
import * as api from "../../api";
import * as account from "../data/account";
import * as affiliate_backend from "../data/affiliate_backend";
import * as image from "../../common/image";
import * as currency from "../../common/currency";
export { api, account, affiliate_backend, image, currency };
import { method, headers, queryStringify } from "../../_util";
export var NameListKey = {
  SHOP_ID: 1
};
export var GlobalSellerTagType = {
  S3P: 1,
  S1P: 2
};
export var AffiliateBackendApi = /*#__PURE__*/function () {
  function AffiliateBackendApi(uriPrefix) {
    this.uriPrefix = typeof uriPrefix !== "undefined" ? uriPrefix : "";
  }
  var _proto = AffiliateBackendApi.prototype;
  _proto.AffiliateAccountInfo = function AffiliateAccountInfo(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/account/info" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.HasAgent = function HasAgent(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/has_agent" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.LogoutAgent = function LogoutAgent(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/log_out_agent" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.GetNameList = function GetNameList(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/name_list/get" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.ListShopViolation = function ListShopViolation(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/violation/shop/list" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.CheckUnreadViolation = function CheckUnreadViolation(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/violation/unread/check";
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.GetCreatorDataFilterOptions = function GetCreatorDataFilterOptions(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/creator_data/filter_option/get" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.GetSellerWithholdTax = function GetSellerWithholdTax(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/withhold_tax/info";
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.SetSellerWithholdTax = function SetSellerWithholdTax(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/withhold_tax/set" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.CheckGrayscaleHitStatus = function CheckGrayscaleHitStatus(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/grayscale_strategy/check" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.CheckGrayscaleHitStatusV2 = function CheckGrayscaleHitStatusV2(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/grayscale_strategy/check";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.GetTodoDashboard = function GetTodoDashboard(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/backend/homepage/todo_dashboard/get";
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.GetTodoList = function GetTodoList(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/backend/homepage/todo_list/get";
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.TodoListConfirm = function TodoListConfirm(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/backend/homepage/todo_list/confirm";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.GetInformationCard = function GetInformationCard(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/backend/homepage/information_card/get";
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.GetSellerAppAffiliateAccountInfo = function GetSellerAppAffiliateAccountInfo(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/backend/app/account/info";
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.GetExternalLinkProgram = function GetExternalLinkProgram(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/backend/homepage/external_link_program/get";
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.UpdateFeatureSwitch = function UpdateFeatureSwitch(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/backend/homepage/feature_switch/update";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  return AffiliateBackendApi;
}();
export var affiliateBackendApiClient = new AffiliateBackendApi();